module.exports = __webpack_public_path__ + "img/multi-win.c8d6e157.png";